import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

export const ToolSpecs = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <tbody>
            {"B" in props.data && (
                <tr>
                    <td>Brand</td>
                    <td>{props.data["B"]}</td>
                </tr>
            )}
            {"M" in props.data && (
                <tr>
                    <td>Model</td>
                    <td>{props.data["M"]}</td>
                </tr>
            )}
            {"T" in props.data && (
                <tr>
                    <td>Type</td>
                    {/* <td>{window.translate_data("item-type", props.data)}</td> */}
                    <td>{t('item-types.' + props.data["T"])}</td>
                </tr>
            )}
            {"A" in props.data && props.data["A"] > 0 && (
                <tr>
                    <td>Axes</td>
                    <td>{props.data["A"]}</td>
                </tr>
            )}
            {"P" in props.data && (
                <tr>
                    <td>Payload</td>
                    <td>{props.data["P"]} kg</td>
                </tr>
            )}
            {"R" in props.data && (
                <tr>
                    <td>Reach</td>
                    <td>{props.data["R"]} mm</td>
                </tr>
            )}
            {"E" in props.data && (
                <tr>
                    <td>Repeatability</td>
                    <td>{props.data["E"]} mm</td>
                </tr>
            )}
            {"W" in props.data && (
                <tr>
                    <td>Weight</td>
                    <td>{props.data["W"]} kg</td>
                </tr>
            )}
        </tbody>
    )
}